import { Navigate, Outlet } from "react-router-dom";
import { orgAdminStorage } from "../../features/org-admin/service";

/** Mirrors AdminRoute, but guards on the ORG-ADMIN session only: a superadmin
 *  logged into /admin/* has no access here, and vice versa. */
const OrgAdminRoute: React.FC = () => {
  const token = orgAdminStorage.getToken();
  const user = orgAdminStorage.getUser();

  if (!token || !user) {
    return <Navigate to="/org-admin/login" replace />;
  }

  return <Outlet />;
};

export default OrgAdminRoute;
